import React from "react";
import { useQuery } from "urql";
import { useParams, Link } from "wouter";
import stableStringify from "json-stable-stringify";

import { BANK_ACCOUNT_TRANSACTIONS_QUERY } from "../../../graphql/src/bankaccounttransaction/queries";
import { BankAccountTransaction } from "../../../graphql/src/types";

export function BankAccountTransactionPage(): React.ReactElement {
    const params = useParams<{ id: string }>();
    const id = params.id;

    const [{ fetching, error, data }] = useQuery<{ bankAccountTransactions?: Partial<BankAccountTransaction>[] }>({
        query: BANK_ACCOUNT_TRANSACTIONS_QUERY,
        requestPolicy: "cache-and-network",
        variables: { filter: { idIn: [id] }, includeVersions: true }
    });

    if (fetching)
        return (
            <div>
                <h3>Loading</h3>
            </div>
        );

    if (error)
        return (
            <div>
                <p>error:</p>
                <pre>{JSON.stringify(error, null, 2)}</pre>
            </div>
        );

    if (!data?.bankAccountTransactions || data.bankAccountTransactions.length === 0)
        return (
            <div>
                <p>No bank account transaction found</p>
            </div>
        );

    const transaction = data.bankAccountTransactions[0];

    return (
        <div>
            <div className="mb-2">
                <Link to="/bankaccounttransactions">Bank account transactions</Link>
            </div>
            <h3>Bank Account Transaction</h3>
            <pre>{stableStringify(transaction, { space: 2 })}</pre>
        </div>
    );
}
